import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";

import "./assets/css/tokens.css";
import "./App.css";
import "./assets/css/global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/js/all.min.js";
import Routers from "./routers/Routers";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { NotificationProvider } from "./providers/NotificationProvider";
import { getEnvVariables } from "./constants/getEnvVariables";

const queryClient = new QueryClient();
const { GOOGLE_OAUTH_CLIENT_ID } = getEnvVariables();

function App() {
  return (
    <HelmetProvider>
      <NotificationProvider>
        <QueryClientProvider client={queryClient}>
          <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
            <ReactQueryDevtools initialIsOpen={false} />
            <BrowserRouter>
              <div
                className="App"
                style={{
                  minHeight: "100vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Routers />
              </div>
            </BrowserRouter>
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </NotificationProvider>
    </HelmetProvider>
  );
}

export default App;
